import axios from "axios";

const ROOT_URL = process.env.REACT_APP_API_URL;

export const getCurrencies = async () => {
    return (await axios.get(`${ROOT_URL}/api/shared/currency`)).data;
}
export const currencyByIso = (currencies, iso) => currencies.find(currency => currency.iso === iso);
